module.exports = __webpack_public_path__ + "static/img/3areaB_3.d8d01b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_3.png
// module id = 1175
// module chunks = 1